import { render } from "./update-workspace.vue?vue&type=template&id=5df7020a&scoped=true"
import script from "./update-workspace.vue?vue&type=script&lang=js"
export * from "./update-workspace.vue?vue&type=script&lang=js"

import "./update-workspace.vue?vue&type=style&index=0&id=5df7020a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df7020a"],['__file',"src/components/applications/admin/update/update-workspace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5df7020a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5df7020a', __exports__)) {
    api.reload('5df7020a', __exports__)
  }
  
  module.hot.accept("./update-workspace.vue?vue&type=template&id=5df7020a&scoped=true", () => {
    api.rerender('5df7020a', render)
  })

}


export default __exports__